import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

const LanguageSelector = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const isFooter = variant === 'footer';

  return (
    <div className="flex items-center gap-2" data-testid="language-selector">
      <Globe className={`w-4 h-4 ${isFooter ? 'text-gray-400' : 'text-gray-600'}`} />
      <Select value={i18n.language} onValueChange={changeLanguage}>
        <SelectTrigger 
          className={`w-[100px] h-8 text-xs ${
            isFooter 
              ? 'bg-white/10 border-white/20 text-white hover:bg-white/20' 
              : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'
          }`}
          data-testid="language-select-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en" className="text-sm" data-testid="language-option-en">
            <span className="flex items-center gap-2">
              <span>🇺🇸</span>
              <span>English</span>
            </span>
          </SelectItem>
          <SelectItem value="es" className="text-sm" data-testid="language-option-es">
            <span className="flex items-center gap-2">
              <span>🇪🇸</span>
              <span>Espanol</span>
            </span>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;
